import styled from "styled-components";

export const StyledInputWrapper = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  font-family: ${(props) => props.theme.typography.textsFont};
  label {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .error-message {
    font-size: 12px;
    margin-top: 8px;
    color: #ef6469;
    width: 100%;
    font-weight: 600;
  }
`;

export const StyledInput = styled.input`
  border: 1px solid ${({ theme }) => theme.colors.skeletonPulse};
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  width: 100%;
  outline: none;
  box-sizing: border-box;
  height: 44px;
  font-family: ${(props) => props.theme.typography.textsFont};

  &::placeholder {
    color: ${({ theme }) => theme.colors.text};
    opacity: 0.5;
    font-size: 14px;
    font-family: ${(props) => props.theme.typography.textsFont};
  }
  &::after {
    content: "show";
    display: block;
  }
  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.text};
  }
`;
